export const getLocationUrl = (locationLike) => {
    if (!locationLike) {
        return '';
    }

    if (typeof locationLike === 'string') {
        return locationLike.trim();
    }

    return `${locationLike.pathname || ''}${locationLike.search || ''}${locationLike.hash || ''}`;
};

export const buildMissingRoute = (locationLike) => {
    const missingUrl = getLocationUrl(locationLike);

    if (!missingUrl) {
        return '/missing';
    }

    const searchParams = new URLSearchParams();
    searchParams.set('url', missingUrl);
    return `/missing?${searchParams.toString()}`;
};

export const getMissingUrlFromSearch = (search) => {
    const searchParams = new URLSearchParams(search || '');
    return searchParams.get('url') || '';
};
